import * as React from 'react';
import Page from '../components/Page';
import SEO from '../components/Seo';
import { LegalSection } from '../sections/Legal';
import { useSiteMetadata } from '../hooks/useSiteMetadata';

export default function DisclaimerPage() {
    return (
        <>
            <Page>
                <LegalSection sectionId="disclaimer" heading="Disclaimer" />
            </Page>
        </>
    );
}

export const Head = () => {
    const siteMetadata = useSiteMetadata();
    const seoProps = {
        title: 'Disclaimer',
        titleTemplate: siteMetadata.titleTemplate,
        description: 'Disclaimer of partner affiliates and customer testimonial statements',
        nofollow: true,
        noindex: true,
    };
    return (
        <>
            <SEO {...seoProps} />
        </>
    );
};
